module.exports = __webpack_public_path__ + "static/media/icon_custom_dragable.371d88a4.svg";